import { __classPrivateFieldGet } from '../../node_modules/tslib/tslib.es6.js';
import { SDKResource } from '../../client/client.js';

// AUTOGENERATED -- DO NOT EDIT
var _Lab_instances, _Lab_baseUrlThunk;
class Lab extends SDKResource {
    constructor(config) {
        super(config);
        _Lab_instances.add(this);
    }
    /**
     * Gets a list of Routes associated with the project. Returns an empty list if no Routes are found.
     *
     * Access Policy Requirements:
     * Action: `Lab:GetRoutes`
     * Access Policy Resource: `Lab:Route`
     */
    routeList(request) {
        return this.request('/route', 'get', __classPrivateFieldGet(this, _Lab_instances, "m", _Lab_baseUrlThunk).bind(this))(request);
    }
    /**
     * Create a route. A Route represents that a lab and particular customer have a relationship, and a Route is necessary to submit an order to a lab. See [Route](https://docs.oystehr.com/oystehr/services/lab/onboarding-a-lab/#create-route) for more details.
     *
     * Access Policy Requirements:
     * Action: `Lab:CreateRoute`
     * Access Policy Resource: `Lab:Route`
     */
    routeCreate(params, request) {
        return this.request('/route', 'post', __classPrivateFieldGet(this, _Lab_instances, "m", _Lab_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Delete a route. Deleting a Route will permanently remove the `routeGuid`. Orders can no longer be submitted to this lab until a new Route is created. See [Route](https://docs.oystehr.com/oystehr/services/lab/onboarding-a-lab/#delete-route) for more details.
     *
     * Access Policy Requirements:
     * Action: `Lab:DeleteRoute`
     * Access Policy Resource: `Lab:Route`
     */
    routeDelete(params, request) {
        return this.request('/route/{routeGuid}', 'delete', __classPrivateFieldGet(this, _Lab_instances, "m", _Lab_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Returns list of active orderable items for the latest compendium version. Page size is default 25 and max 100 items. See [orderable item Search](https://docs.oystehr.com/oystehr/services/lab/explore-the-compendium/#orderable-item-search) for more details.
     *
     * Access Policy Requirements:
     * Action: `Lab:SearchOrderableItems`
     * Access Policy Resource: `Lab:OrderableItem`
     */
    orderableItemList(params, request) {
        return this.request('/orderableItem', 'get', __classPrivateFieldGet(this, _Lab_instances, "m", _Lab_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Retrieve the AOE (Answer on Entry) Questionnaire for the given orderable item. The orderable item is defined by its labGuid, compendiumVersion, and itemCode. See [AOE](https://docs.oystehr.com/oystehr/services/lab/explore-the-compendium/#AOE) for more details.
     *
     * Access Policy Requirements:
     * Action: `Lab:SearchOrderableItems`
     * Access Policy Resource: `Lab:OrderableItem`
     */
    orderableItemQuestionnaireGet(params, request) {
        return this.request('/canonical-questionnaire/lab/{labGuid}/compendium/{compendiumVersion}/item/{itemCode}/questionnaire', 'get', __classPrivateFieldGet(this, _Lab_instances, "m", _Lab_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Submit a lab order. Oystehr's [Submit Lab](https://docs.oystehr.com/oystehr/services/lab/submit-an-order/) feature allows users to submit a well configured ServiceRequest to an external lab. In order to successfully submit an order, a [Route](https://docs.oystehr.com/oystehr/services/lab/onboarding-a-lab/#create-route) to and Organization representing that lab must exist.
     *
     * Access Policy Requirements:
     * Action: `Lab:SubmitOrder`
     * Access Policy Resource: `Lab:Order`
     */
    orderSubmit(params, request) {
        return this.request('/submit', 'post', __classPrivateFieldGet(this, _Lab_instances, "m", _Lab_baseUrlThunk).bind(this))(params, request);
    }
}
_Lab_instances = new WeakSet(), _Lab_baseUrlThunk = function _Lab_baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['labApiUrl']) !== null && _b !== void 0 ? _b : 'https://labs-api.zapehr.com/v1';
};

export { Lab };
//# sourceMappingURL=lab.js.map
